/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Página não encontrada",
  "ComingSoon": "Em breve",
  "YesanPersonalFinance": "Yesan, Finanças pessoais",
  "Yesan": "Yesan",
  "PersonalFinance": "Finanças pessoais",
  "YesanDownload": "Download do Yesan",
  "ThisWebsiteUsesCookies": "Utilizamos cookies para recolher e analisar informações sobre o desempenho e a utilização do nosso sítio e para fornecer funcionalidades de redes sociais. Ao continuar, está a concordar com a nossa",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Torne-se financeiramente livre",
  "inStepsAndActions": "em 8 passos e 3 acções.",
  "TrackPlanAnalyze": "Acompanhar. Planear. Analisar.",
  "FTrack": "1. Acompanhar",
  "FPlan": "2. Planear",
  "FAnalyze": "3. Analisar",
  "Features": "Características",
  "FeaturesSubHeading": "Puro principiante, já com conhecimentos financeiros, esta é a aplicação de que necessita para se tornar financeiramente livre.",
  "ManageAccounts": "Gerir contas",
  "CashLiquidFixedAssetsLiabilities": "Dinheiro, líquido, activos fixos e passivos.",
  "TrackTransactions": "Acompanhar transacções",
  "IncomesExpensesTransferInvestments": "Receitas, despesas, transferências, investimentos.",
  "ImportExport": "Importar / Exportar",
  "YourDataAlwaysAccessible": "Os seus dados sempre acessíveis.",
  "PlanYourFreedom": "Planeie a sua liberdade",
  "StepsAwayFromFI": "A 8 passos da Independência Financeira.",
  "BudgetsAndGoals": "Orçamentos e Objectivos",
  "CheckYourProgressAndAchieve": "Verifique o seu progresso e atinja os seus objectivos financeiros.",
  "DashboardAndAnalytics": "Painel de controlo e análise",
  "ReviewLearnOptimizeWith": "Reveja, aprenda, optimize com gráficos, informações e ferramentas.",
  "Security": "Segurança",
  "MilitaryGradeEncryption": "Encriptação de nível militar, suporte de biometria, dados armazenados nos seus dispositivos.",
  "OfflineMode": "Modo offline",
  "YourDataAlwaysAccessibleAndModif": "Os seus dados sempre acessíveis e modificáveis.",
  "Track": "Controlo",
  "Income": "Rendimento",
  "Expense": "Despesas",
  "Transfer": "Transferir",
  "transactionsAndManageAccounts": "transacções e gerir uma variedade de contas:",
  "checkings": "Conta corrente",
  "savings": "Poupança",
  "realEstate": "Imóveis",
  "stocks": "Bolsas de valores",
  "bonds": "Obrigações",
  "crypto": "Criptografia",
  "notes": "Notas, dinheiro Carteira",
  "envelopes": "Envelopes",
  "privateEquity": "Património privado",
  "metal": "Metal",
  "retirement": "Reforma",
  "lifeInsurance": "Seguro de vida",
  "intellectualProperty": "Propriedade intelectual",
  "otherLiquidAsset": "Outros activos líquidos",
  "otherFixedAsset": "Outro ativo fixo",
  "mortgage": "Hipoteca",
  "loan": "Crédito ao consumo",
  "creditCard": "Cartão de crédito",
  "otherLiability": "Outros passivos",
  "AccountsManagement": "Gestão de contas",
  "MultipleAccountsTypesAndGrouping": "Múltiplos tipos e agrupamentos de contas",
  "LinkAccounts": "Ligação de contas das suas instituições (disponível apenas em alguns países)",
  "SmartAccounts": "Contas inteligentes",
  "AddEditDeleteTransactions": "Adicionar / Editar / Eliminar transacções",
  "TickVerifiedTransactions": "Assinalar transacções verificadas",
  "CategorizeTransactions": "Categorizar transacções",
  "TagTransactions": "Etiquetar transacções",
  "TrackKakeiboType": "Seguir o tipo de Kakeibo",
  "TrackInvestments": "Acompanhar investimentos (disponível apenas em alguns países)",
  "ImportFromCSVFile": "Importar transacções completas ou incrementais a partir de um ficheiro CSV",
  "ExportToCSVFile": "Exportar transacções para um ficheiro CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "Plano de 8 passos para a Independência Financeira, orçamento detalhado, alcance os seus objectivos financeiros mais rapidamente.",
  "levelsTowardsFI": "8 níveis para a Independência Financeira",
  "EstablishBudgetsPer": "Estabelecer orçamentos por",
  "account": "conta",
  "accountType": "tipo de conta",
  "KakeiboType": "Tipo de Kakeibo",
  "category": "categoria",
  "tag": "etiqueta",
  "label": "etiqueta",
  "TrackBudgetsPerFrequency": "Acompanhar os orçamentos por frequência",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Criar objectivos sobre despesas, saldo, fluxo de caixa, acções",
  "TrackGoalsProgress": "Acompanhar o progresso dos objectivos",
  "ReviewLearnOptimizeWithReportsCharts": "Rever, aprender, otimizar com relatórios, gráficos, tendências, informações, ferramentas.",
  "Dashboard": "Painel de controlo",
  "FSNetWorth": "Demonstrações financeiras: Património líquido",
  "FSPnL": "Demonstrações financeiras: Demonstração de resultados / Lucros e perdas",
  "FSBalanceSheetAssetsLiabilities": "Demonstrações financeiras: Balanço, activos, passivos",
  "FSCashFlow": "Demonstrações financeiras: Demonstração de Fluxos de Caixa, Débito Crédito, Fluxos",
  "FSFlows": "Demonstrações financeiras: Fluxos",
  "FSRatios": "Demonstrações financeiras: Rácios",
  "TrendsMonthEnd": "Tendências de fim de mês: Receitas e despesas, fluxo de caixa",
  "TrendsPerformance": "Tendências de desempenho: YoY, MoM, WoW",
  "IncomeTrendsPer": "Tendências de rendimento por",
  "SpendingTrendsPer": "Tendências de gastos por",
  "RecurringItemsIE": "Itens recorrentes: Receitas e despesas",
  "DebtProgressTrends": "Tendências de evolução da dívida",
  "KakeiboMTDReviewTrends": "Kakeibo: Revisão MTD, último mês, tendências",
  "FIWCLE": "Independência financeira: Gráfico de parede, despesas por energia vitalícia",
  "DebtPaydownSnowballAvalanche": "Pagamento de dívidas: Bola de neve, Avalanche",
  "FullyCustomizableAnalyticsRange": "Intervalo de tempo de análise totalmente personalizável",
  "ContactUs": "Contacte-nos",
  "Privacy": "Privacidade",
  "Terms": "Condições de utilização",
  "About": "Acerca de",
  "IAgreeToThe": "Concordo com os",
  "AndThe": "e a",
  "PrivacyPolicy": "Política de Privacidade",
  "TermsOfUse": "Termos de utilização",

  "DigitalSoftwareExperienceTagline": "Experiência de software digital para o mundo moderno",
  "DigitalExperience": "Experiência digital",
  "SoftwareForTheModernWorld": "Software para o mundo moderno",
  "MobileApplications": "Aplicações móveis",
  "forConnectedAndOfflineHumans": "para pessoas conectadas e offline",
  "CloudSaaS": "Nuvem SaaS",
  "ResponsiveAndWebServices": "Serviços Web e responsivos",
  "PersonalFinanceServices": "Serviços de finanças pessoais",
  "YS_p1": "A Yesan é uma empresa de software dinâmica, especializada no desenvolvimento de aplicações móveis de vanguarda adaptadas aos consumidores. Com uma compreensão profunda das necessidades e preferências em evolução dos utilizadores tecnológicos de hoje, a Yesan dedica-se a criar experiências móveis intuitivas, envolventes e ricas em funcionalidades que enriquecem a vida dos seus utilizadores.",
  "YS_p2": "No centro da missão da Yesan está um compromisso incansável com a inovação e a criatividade, cada produto é meticulosamente criado para proporcionar uma funcionalidade perfeita e uma experiência de utilizador excecional.",
  "PersonalFinanceApplication": "Aplicação de finanças pessoais",
  "YPF_p1": "Yesan, Personal Finance é uma aplicação móvel de finanças pessoais de ponta, concebida para dar aos utilizadores ferramentas de gestão financeira abrangentes, convenientemente acessíveis na ponta dos dedos. Com uma interface elegante e intuitiva, a Yesan, Personal Finance oferece uma abordagem holística à gestão das finanças, atendendo a utilizadores de todos os níveis de literacia financeira.",
  "YPF_p2": "As principais características incluem o controlo do orçamento, a categorização das despesas e a monitorização das transacções em tempo real, permitindo aos utilizadores obter informações sobre os seus hábitos de despesa sem esforço. A aplicação também oferece opções de orçamento personalizáveis, permitindo aos utilizadores definir objectivos financeiros e acompanhar o seu progresso ao longo do tempo.",
  "YPF_p3": "Além disso, a Yesan, Personal Finance dá prioridade à segurança, empregando protocolos de encriptação de última geração para salvaguardar as informações financeiras sensíveis dos utilizadores. Com medidas de segurança de nível bancário, os utilizadores podem associar com confiança as suas contas e sincronizar transacções sem comprometer a privacidade.",
  "YPF_p4": "Yesan, Personal Finance vai além da orçamentação básica, oferecendo análises perspicazes e recomendações personalizadas para otimizar as decisões financeiras. Quer se trate de identificar potenciais oportunidades de poupança, monitorizar carteiras de investimento ou gerir estratégias de pagamento de dívidas, a aplicação fornece informações personalizadas para ajudar os utilizadores a atingir os seus objectivos financeiros.",
  "Discover": "Descobrir",
  "Firstname": "Nome próprio",
  "Lastname": "Apelido",
  "Company":"Empresa",
  "Subject": "Assunto",
  "Email": "Correio eletrónico",
  "Message": "Mensagem",
  "ThankYouForContactingUs": "Obrigado por nos contactar",
  "ValidFirstnameRequired": "É necessário um nome próprio válido.",
  "ValidLastnameRequired": "É necessário um apelido válido.",
  "ValidEmailAddressRequired": "Introduza um endereço de correio eletrónico válido.",
  "ValidSubjectRequired": "Por favor, seleccione um assunto válido.",
  "ValidMessageRequired": "Por favor, introduza uma mensagem válida.",
  "UnableToSendTheFormPleaseRetryLater": "Não foi possível enviar o formulário, tente novamente mais tarde.",
  "Information": "Informação",
  "Sales":"Vendas",
  "Support": "Apoio",
  "Press": "Imprensa",
  "Partnership": "Parcerias",
  "Other": "Outros",
  "Blog":"Blogue",

  "Accept":"Aceitar",
  "Decline":"Recusar",

  "WorklogCalendar":"Calendário de trabalho para o Jira",

  "DirectlyAccessibleInProjectApps":"Diretamente acessível em aplicações de projeto",
  "VisualizeWhereYouSpentYourTime":"Visualize onde gastou o seu tempo",
  "AllYourWorklogsInACalendar":"Todos os seus registos de trabalho num calendário",
  "MonthSummary":"Resumo do mês",
  "CheckIfYouForgotToLogTime":"Verifique se se esqueceu de registar o tempo.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Aceder diretamente aos problemas e atualizar o tempo",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Clique no item do registo de trabalho para aceder diretamente aos problemas e editar o seu tempo registado",
  "AlsoAvailableInDarkMode":"Também disponível em modo escuro",
  "DirectlyLogWorkOnTheCalendarVisually":"Registar visualmente o trabalho diretamente no calendário",
  "ClickOnTheCalendarToCreateNewWorklog":"Clique no calendário para criar um novo registo de trabalho",

  "AppsForAtlassian":"Aplicações para a Atlassian",
  "YCL_p1":"Visualize todos os seus worklogs num calendário com vistas de mês, semana, semana de trabalho e dia.",
  "YCL_p2":"Registe o trabalho diretamente no calendário, selecionando visualmente o intervalo de tempo.",
  "YCL_p3":"Identifique se se esqueceu de registar o tempo nas suas folhas de horas.",
  "YCL_p4":"Disponível na sua língua: Inglês (Reino Unido), Inglês (EUA), Chinês (Simplificado), Chinês (Tradicional), Checo, Dinamarquês, Neerlandês, Estónio, Finlandês, Francês, Alemão, Húngaro, Islandês, Italiano, Japonês, Coreano, Norueguês, Polaco, Português (Brasil), Português (Portugal), Russo, Espanhol, Sueco, Turco.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Portfólio Financeiro para o Jira",
  "BringRealFinancialPortfolio":"Leve a gestão real do portfólio financeiro para o Jira. Acompanhe orçamentos, CapEx/OpEx e custos de projetos num único local.",
  "YFPAboutQ":"Quanto nos custam realmente os nossos projetos do Jira?",
  "YFPAbout":"Portfólio Financeiro para o Jira\nOs responsáveis financeiros e os PMOs têm dificuldade em responder a uma pergunta simples:\nQuanto nos estão realmente a custar os nossos projetos do Jira?\nO Jira acompanha o trabalho.\nO departamento financeiro acompanha os orçamentos.\nEsta aplicação finalmente liga os dois.\n\nO Portfólio Financeiro transforma o Jira numa plataforma leve de PPM + planeamento financeiro — sem necessidade de ferramentas empresariais dispendiosas.",
  "YFPPorfolioQ":"Orçamentos e Acompanhamento de Portfólios",
  "YFPPorfolioP":"Crie portfólios em vários projetos Jira e defina: Montante do orçamento, Moeda, Intervalo de datas, Projetos incluídos, equipas. Acompanhe os custos reais automaticamente à medida que o trabalho decorre no Jira.",
  "YFPPorfolioListQ":"Portfólios",
  "YFPPorfolioListP":"Crie portfólios financeiros que combinam vários projetos do Jira e veja instantaneamente: Orçamento vs. Custo real, Taxa de queima do projeto em tempo real, Discriminação de CapEx vs. OpEx, Custo por issue e projeto, Relatórios financeiros exportáveis. Tudo alimentado diretamente pelos registos de trabalho do Jira.",
  "CostQ":"Cálculo automático de custos",
  "CostP":"Transforme o registo de tempo em dados financeiros reais. A aplicação: lê os registos de trabalho do Jira, aplica tarifas horárias, calcula diariamente os custos reais dos projetos. Sem folhas de cálculo. Sem trabalho manual.",
  "RatesQ":"Tarifas",
  "RatesP":"Defina a tarifa horária por projeto, equipa, globalmente",
  "ReportQ":"Relatórios financeiros em CSV",
  "ReportP":"Exporte dados financeiros do portfólio em segundos. Ideal para: Equipas financeiras, relatórios do CFO, planeamento orçamental, apoio à auditoria",
  "SettingsQ":"Classificação CapEx vs OpEx",
  "SettingsP":"Apoie os requisitos de contabilidade e auditoria. Classifique o trabalho em: Desenvolvimento capitalizável (CapEx), Trabalho operacional (OpEx). Gere relatórios exportáveis prontos para as equipas financeiras."
};

export const documents = {
};
